module.exports = __webpack_public_path__ + "static/media/alert-icon.809aa7df.svg";